import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./unauthorized.css";

const Unauthorized = () => {
  const navigate = useNavigate();
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const handleGoBack = () => {
    // window.location.href = `${accountsUrl}`;
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie =
      "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie =
      "mawalog=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    window.location.href = `${accountsUrl}/login`;
  };

  return (
    <Container
      fluid
      className="unauthorized-container"
      style={{
        width: "100vw",
        minHeight: "100vh",
        padding: "0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fb",
      }}
    >
      <div className="unauthorized-card">
        {/* Icon - Prohibition/Denied Icon */}
        <div className="unauthorized-icon">
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Outer circle */}
            <circle cx="50" cy="50" r="45" fill="#FEE2E2" stroke="#DC2626" strokeWidth="3" />

            {/* Diagonal line (slash) */}
            <line
              x1="28"
              y1="28"
              x2="72"
              y2="72"
              stroke="#DC2626"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="unauthorized-title">Access Denied</h1>

        {/* Message */}
        <p className="unauthorized-message">
          You don't have permission to access this page. Please contact your administrator
          if you believe this is a mistake.
        </p>

        {/* Error Code */}
        <p className="unauthorized-code">Error 403 - Forbidden</p>

        {/* Action Buttons */}
        <div className="unauthorized-actions">
          <Button
            className="btn-primary"
            onClick={handleGoBack}
            style={{
              backgroundColor: "#3D4AF5",
              border: "none",
              borderRadius: "100px",
              fontWeight: "600",
              fontSize: "14px",
              padding: "10px 24px",
              marginRight: "12px",
            }}
          >
            Go Back
          </Button>
         {/*  <Button
            className="btn-secondary"
            onClick={handleLogout}
            style={{
              backgroundColor: "transparent",
              border: "1.5px solid #D4DDE7",
              borderRadius: "100px",
              fontWeight: "600",
              fontSize: "14px",
              color: "#172b4d",
              padding: "10px 24px",
            }}
          >
            Logout
          </Button> */}
        </div>
      </div>

      {/* Footer Info */}
      <div className="unauthorized-footer">
        <p style={{ fontSize: "13px", color: "#8790A1", marginBottom: "0" }}>
          If you continue to experience issues, please contact support.
        </p>
      </div>
    </Container>
  );
};

export default Unauthorized;
